import { useContext } from 'react';
import { ThemeContext } from '@/contexts/theme-context';
import { SectionContext } from '@/contexts/section-context';
import omit from '@/utils/omit';

const useThemeBlock = (slug, theme = {}, variant = '') => {
	const themeFromContext = useContext(ThemeContext).theme;
	const currentTheme =
		Object.keys(themeFromContext).length > 0 ? themeFromContext : theme;
	const currentVariant =
		variant || useContext(SectionContext)?.['variant'] || 'default';
	const blockFullTheme = currentTheme?.['blocks']?.[slug];
	const blockTheme =
		currentVariant == 'default'
			? omit(blockFullTheme, ['variants'])
			: blockFullTheme?.variants?.[currentVariant];

	return { variant: currentVariant, blockTheme };
};
export default useThemeBlock;
